import { getCadPlanBackgroundColor } from '../../Map/styles/mapTheme';

export const CAD_PLAN_BACKGROUND_LAYER_ID = 'background';

/**
 * Estilo MapLibre sin teselas ni PMTiles. Solo fondo neutro.
 * @param {'dark'|'light'} [background]
 * @returns {object}
 */
export function buildCadPlanMapStyle(background = 'dark') {
  return {
    version: 8,
    // Mismos glifos que el mapa país: sin esto el plano no puede pintar texto.
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
    sources: {},
    layers: [
      {
        id: CAD_PLAN_BACKGROUND_LAYER_ID,
        type: 'background',
        paint: { 'background-color': getCadPlanBackgroundColor(background) },
      },
    ],
  };
}

/**
 * Cambia el fondo del plano sin recrear el mapa (conserva cámara).
 * @param {{ getLayer?: Function, setPaintProperty?: Function }|null} map
 * @param {'dark'|'light'} background
 */
export function setCadPlanBackground(map, background) {
  if (!map?.getLayer?.(CAD_PLAN_BACKGROUND_LAYER_ID)) return;
  try {
    map.setPaintProperty(
      CAD_PLAN_BACKGROUND_LAYER_ID,
      'background-color',
      getCadPlanBackgroundColor(background),
    );
  } catch (_) {
    /* estilo todavía no listo */
  }
}
